export default __webpack_public_path__ + "static/media/brand4.b38a34bd.png";